import { render, staticRenderFns } from "./OrdersFBMTable.vue?vue&type=template&id=b413188e&scoped=true"
import script from "./OrdersFBMTable.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b413188e",
  null
  
)

export default component.exports